// 进入首页验证token检测用户的状态
// url：/jeecg-boot/marco/auth/getUserInfo
export const checkToken = () => {
  const URL = "/marco/auth/getUserInfo";
  return getApi(URL);
};

// 退出登录
// url: /jeecg-boot/marco/auth/logout
export const logout = () => {
  const URL = "/marco/auth/logout";
  return postApi(URL);
};

// 获取手机区号
// url: "/marco/auth/queryPhoneAreaCode"/account/api/v1/queryPhoneAreaCode
export const getPhoneAreaNumber = () => {
  const URL = "/account/api/v1/queryPhoneAreaCode";
  return getApi(URL);
};

// 获取知晓渠道
// url: "/marco/auth/queryDiscoveryChannel"
export const getDiscoveryChannel = () => {
  const URL = "/marco/auth/queryDiscoveryChannel";
  return getApi(URL);
};

// 获取验证码
// url: "/sys/randomImage" + 时间戳
export const getCode = (currDatetime: number) => {
  const URL = "/marco/auth/randomImage" + `/${currDatetime}`;
  return getApi(URL);
};

// 注册
// url: "/marco/auth/marcoAccountCreate" 请求体加表单数据
export const createAccount = (options: any) => {
  const URL = "/marco/auth/marcoAccountCreate";
  return postApi(URL, options);
};

// 登录
// url: "/marco/auth/marcoLogin" 请求头加账号密码
export const signIn = (options: any) => {
  const URL = "/marco/auth/marcoLogin";
  return postApi(URL, options);
};

// 发送邮箱验证码
// url : /marco/auth/sendEmailVerifyCode
// query:email
export const sendEmailVerifyCode = (email: string) => {
  const URL = `/marco/auth/sendEmailVerifyCode?email=${email}`;
  return postApi(URL);
};

// 验证邮箱验证码
// url: /marco/auth/verifyEmailCode
// query: email  verifyCode
export const verifyEmailCode = (data: {
  email: string;
  verifyCode: string;
}) => {
  const URL = `/marco/auth/verifyEmailCode?email=${data.email}&verifyCode=${data.verifyCode}`;
  return postApi(URL);
};

// 邮箱链接点击验证
// url: /marco/auth/verifyEmailByLink`
export const verifyEmailByLink = (generateCode: string) => {
  const URL = `/marco/auth/verifyEmailByLink?generate=${generateCode}`;
  return postApi(URL);
};

// 发送重设密码邮箱验证码
export const sendEmailVerifyCodeForReseting = (email: string) => {
  const URL = `/marco/auth/sendForgetPasswordVerifyEmail?email=${email}`;
  return postApi(URL);
};

// 重设密码
export const resetPassword = (options: any) => {
  const URL = `/marco/auth/verifyForgetPasswordEmailCode`;
  return postApi(URL,options);
};